import React, { useState, useEffect } from "react";
import { useParams, Link, useNavigate } from "react-router-dom";
import logo from "../../../../img/logo rio verde pdf.png";
import ExpenseTablePopup from "../../ExpensePages/ExpenseTablePopup/ExpenseTablePopup";
import RegisterDesramaPopup from "../../DesramaPages/RegisterDesramaPopup/RegisterDesramaPopup";
import DesramaTablePopup from "../../DesramaPages/DesramaTablePopup/DesramaTablePopup";
import RegisterDesbastePopup from "../../DesbastePages/RegisterDesbasteTablePopup/RegisterDesbastePopup";
import DesbasteTablePopup from "../../DesbastePages/DesbasteTablePopup/DesbasteTablePopup";
import RegisterDespesaPopup from "../../ExpensePages/RegisterDespesaPopup/RegisterDespesaPopup";
import NotasModal from "../../Notas/NotasModal";
import EditImovelModal from "../EditImovelModal/EditImovelModal";
import InventoryModal from "../../Inventario/InventoryModal/InventoryModal";
import { API_BASE_URL } from "../../../../config";
import styles from "./ImovelDetails.module.css";
import { generateImovelReport } from './reportGeneratorImovelDetails';
import ArquivosPopup from '../../Arquivos/ArquivosPopup';
import { FaDollarSign, FaLeaf, FaClipboardList, FaFilePdf, FaPlus, FaTasks, FaStickyNote, FaFolderOpen, FaEdit, FaClipboardCheck } from 'react-icons/fa';
import { FiArrowLeft } from 'react-icons/fi';
import PageHeader from '../../../../components/PageHeader/PageHeader';
import LoadingOverlay from "../../../../components/LoadingOverlay/LoadingOverlay";

const ImovelDetails = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const [imovel, setImovel] = useState(null);
    const [contractExpirationAlert, setContractExpirationAlert] = useState("");
    const [pageLoading, setPageLoading] = useState(true);

    const [isDespesaPopupOpen, setIsDespesaPopupOpen] = useState(false);
    const [isViewExpensePopupOpen, setIsViewExpensePopupOpen] = useState(false);
    const [isDesbasteTableOpen, setIsDesbasteTableOpen] = useState(false);
    const [isDesramaTableOpen, setIsDesramaTableOpen] = useState(false);
    const [isDesramaPopupOpen, setIsDesramaPopupOpen] = useState(false);
    const [isDesbastePopupOpen, setIsDesbastePopupOpen] = useState(false);
    const [isNotasModalOpen, setIsNotasModalOpen] = useState(false);
    const [isReportModalOpen, setIsReportModalOpen] = useState(false);
    const [isEditModalOpen, setIsEditModalOpen] = useState(false);
    const [isInventoryModalOpen, setIsInventoryModalOpen] = useState(false);
    const [isArquivosPopupOpen, setIsArquivosPopupOpen] = useState(false);
    const [selectedFields, setSelectedFields] = useState({});

    const checkContractExpiration = (vencimentoContrato) => {
        const today = new Date();
        const vencimentoDate = new Date(vencimentoContrato);
        const diffTime = vencimentoDate - today;
        if (diffTime < 0) {
            return "Contrato já venceu!";
        }
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
        if (diffDays <= 30) {
            return `Contrato prestes a vencer em ${diffDays} dias.`;
        }
        return null;
    };
    
    const fetchImovelDetails = async () => {
        const token = localStorage.getItem('token');
        if (!token) {
            console.error("Usuário não autenticado. Redirecionando para login.");
            navigate('/');
            return;
        }

        try {
            const response = await fetch(`${API_BASE_URL}/api/imoveis/${id}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                }
            });

            if (response.status === 401 || response.status === 400) {
                console.error("Token inválido ou expirado. Redirecionando para login.");
                localStorage.removeItem('token');
                navigate('/');
                return;
            }

            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.error || "Imóvel não encontrado");
            }

            const data = await response.json();
            setImovel(data);
            if (data.vencimento_contrato) {
                setContractExpirationAlert(checkContractExpiration(data.vencimento_contrato));
            } else {
                setContractExpirationAlert("");
            }
        } catch (error) {
            console.error("Erro ao buscar detalhes do imóvel:", error.message);
            setImovel(undefined);
        }
    };

    useEffect(() => {
        const MIN_LOADING_TIME = 300;
        const startTime = Date.now();
        setPageLoading(true);

        const loadImovel = async () => {
            const token = localStorage.getItem('token');
            if (!token) {
                console.error("Usuário não autenticado. Redirecionando para login.");
                navigate('/');
                return;
            }
    
            try {
                const response = await fetch(`${API_BASE_URL}/api/imoveis/${id}`, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`
                    }
                });
    
                if (response.status === 401 || response.status === 400) {
                    console.error("Token inválido ou expirado. Redirecionando para login.");
                    localStorage.removeItem('token');
                    navigate('/');
                    return;
                }
    
                if (!response.ok) {
                    const errorData = await response.json();
                    throw new Error(errorData.error || "Imóvel não encontrado");
                }
    
                const data = await response.json();
                setImovel(data);
                if (data.vencimento_contrato) {
                    setContractExpirationAlert(checkContractExpiration(data.vencimento_contrato));
                } else {
                    setContractExpirationAlert("");
                }
            } catch (error) {
                console.error("Erro ao buscar detalhes do imóvel:", error.message);
                setImovel(undefined);
            } finally {
                const endTime = Date.now();
                const duration = endTime - startTime;
                const remainingTime = MIN_LOADING_TIME - duration;
    
                if (remainingTime > 0) {
                    setTimeout(() => setPageLoading(false), remainingTime);
                } else {
                    setPageLoading(false);
                }
            }
        };

        loadImovel();
    }, [id, navigate]);
    
    const handleOpenDespesaPopup = () => setIsDespesaPopupOpen(true);
    const handleCloseDespesaPopup = () => setIsDespesaPopupOpen(false);
    const handleOpenViewExpensePopup = () => setIsViewExpensePopupOpen(true);
    const handleCloseViewExpensePopup = () => setIsViewExpensePopupOpen(false);
    const handleOpenDesbastePopup = () => setIsDesbastePopupOpen(true);
    const handleCloseDesbastePopup = () => setIsDesbastePopupOpen(false);
    const handleOpenDesbasteTable = () => setIsDesbasteTableOpen(true);
    const handleCloseDesbasteTable = () => setIsDesbasteTableOpen(false);
    const handleDesramaTableOpen = () => setIsDesramaTableOpen(true);
    const handleDesramaTableClose = () => setIsDesramaTableOpen(false);
    const handleOpenNotasModal = () => setIsNotasModalOpen(true);
    const handleCloseNotasModal = () => setIsNotasModalOpen(false);
    const handleOpenEditModal = () => setIsEditModalOpen(true);
    const handleCloseEditModal = () => setIsEditModalOpen(false);
    const handleOpenInventoryModal = () => setIsInventoryModalOpen(true);
    const handleCloseInventoryModal = () => setIsInventoryModalOpen(false);
    const handleOpenArquivosPopup = () => setIsArquivosPopupOpen(true);
    const handleCloseArquivosPopup = () => setIsArquivosPopupOpen(false);
    
    const handleSaveImovel = () => {
        fetchImovelDetails();
        handleCloseEditModal();
    };

    const handleSelectAll = () => {
        const allFieldsSelected = Object.keys(imovel).every(
            (key) => selectedFields[key] || key === "id" || key === "descricao"
        );
        const newSelectedFields = {};
        Object.keys(imovel).forEach((key) => {
            if (key !== "id" && key !== "descricao") {
                newSelectedFields[key] = !allFieldsSelected;
            }
        });
        setSelectedFields(newSelectedFields);
    };

    const handleGenerateReport = () => {
        generateImovelReport({ imovel, selectedFields, logo });
        setIsReportModalOpen(false);
    };
    
    const handleFieldChange = (e) => {
        setSelectedFields({ ...selectedFields, [e.target.name]: e.target.checked });
    };
    
    const formatValue = (value, key) => {
        if (value === null || value === undefined || value === "N/A" || value === "") return null;

        const dateFields = ["data_plantio", "data_contrato", "vencimento_contrato", "data_divisao_percentual"];
        const areaFields = ["area_imovel", "area_plantio", "area_plantio_arrendatario", "area_plantio_arrendadores"];
        const percentageFields = ["percentual_arrendatario", "percentual_arrendadores"];
        const numberFields = ["num_arvores_plantadas", "num_arvores_cortadas", "num_arvores_remanescentes", "num_arvores_por_hectare", "altura_desrama"];

        if (dateFields.includes(key) && value) {
            const dateValue = new Date(value);
            return !isNaN(dateValue.getTime()) ? dateValue.toLocaleDateString("pt-BR", { timeZone: 'UTC' }) : null;
        }
        if (areaFields.includes(key)) {
            const numericValue = Number(value);
            return isFinite(numericValue) ? numericValue.toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : null;
        }
        if (percentageFields.includes(key)) {
            const numericValue = Number(value);
            return isFinite(numericValue) ? `${numericValue.toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })} %` : null;
        }
        if (numberFields.includes(key)) {
            const numericValue = Number(value);
            if (isFinite(numericValue)) {
                return numericValue.toLocaleString("pt-BR");
            }
        }
        return String(value);
    };

    const fieldLabels = {
        descricao: "Descrição", area_imovel: "Área do Imóvel (ha)", area_plantio: "Área de Plantio (ha)",
        especie: "Espécie", origem: "Origem", num_arvores_plantadas: "Nº de Árvores Plantadas",
        num_arvores_cortadas: "Nº de Árvores Cortadas", num_arvores_remanescentes: "Nº de Árvores Remanescentes",
        num_arvores_por_hectare: "Nº de Árvores por Hectare", matricula: "Matrícula", data_plantio: "Data de Plantio",
        numero_ccir: "Número CCIR", numero_itr: "Número ITR", proprietario: "Proprietário",
        arrendatario: "Arrendatário", data_contrato: "Data do Contrato", vencimento_contrato: "Vencimento do Contrato",
        municipio: "Município", localidade: "Localidade", altura_desrama: "Altura da Desrama",
        numero_car: "Número do CAR", codigo_cc: "Código CC",
        percentual_arrendatario: "Percentual do Arrendatário",
        percentual_arrendadores: "Percentual dos Arrendadores",
        area_plantio_arrendatario: "Área do Arrendatário (ha)",
        area_plantio_arrendadores: "Área dos Arrendadores (ha)",
        data_divisao_percentual: "Data da Divisão",
    };
    
    return (
        <div className={styles.pageContainer}>
            {pageLoading && <LoadingOverlay text="Carregando imóvel..." />}

            {!pageLoading && (
                <>
                    {imovel === undefined && (
                        <>
                            <PageHeader title="Erro" subtitle="Imóvel não encontrado." backTo="/view-imoveis" />
                            <div className={styles.contentWrapper}>
                                <p>O imóvel que você está tentando acessar não foi encontrado.</p>
                            </div>
                        </>
                    )}

                    {imovel && (
                        <>
                            <PageHeader 
                                title={imovel.descricao}
                                subtitle="Visualize os detalhes e gerencie todas as operações do imóvel."
                                backTo="/view-imoveis"
                            />
                            
                            <div className={styles.contentWrapper}>
                                {contractExpirationAlert && (
                                    <div className={styles.propertyAlert}>
                                        <strong>Atenção!</strong> {contractExpirationAlert}
                                    </div>
                                )}

                                <div className={styles.propertyDetails}>
                                    {Object.keys(imovel).map((key) => {
                                        if (key === "id" || key === "descricao") return null;
                                        const formattedValue = formatValue(imovel[key], key);
                                        const label = fieldLabels[key] || key;
                                        if (formattedValue === null) return null;
                                        return (
                                            <div className={styles.propertyDetail} key={key}>
                                                <span className={styles.propertyLabel}>{label}:</span>
                                                <span className={styles.propertyValue}>{formattedValue}</span>
                                            </div>
                                        );
                                    })}
                                </div>

                                <div className={styles.actionsContainer}>
                                    <div className={styles.actionsGroup}>
                                        <h3 className={styles.actionsGroupTitle}><FaDollarSign /> Gestão Financeira</h3>
                                        <button onClick={handleOpenDespesaPopup} className={styles.customButton}><FaPlus /> Registrar Despesa</button>
                                        <button onClick={handleOpenViewExpensePopup} className={styles.customButton}><FaFilePdf /> Relatório de Despesas</button>
                                    </div>

                                    <div className={styles.actionsGroup}>
                                        <h3 className={styles.actionsGroupTitle}><FaLeaf /> Manejo Florestal</h3>
                                        <button onClick={() => setIsDesramaPopupOpen(true)} className={styles.customButton}><FaPlus /> Registrar Desrama</button>
                                        <button onClick={handleDesramaTableOpen} className={styles.customButton}><FaTasks /> Relatório de Desrama</button>
                                        <button className={styles.customButton} onClick={handleOpenDesbastePopup}><FaPlus /> Registrar Desbaste</button>
                                        <button className={styles.customButton} onClick={handleOpenDesbasteTable}><FaTasks /> Relatório de Desbaste</button>
                                        <button className={styles.customButton} onClick={handleOpenInventoryModal}><FaClipboardCheck /> Inventário</button>
                                    </div>

                                    <div className={styles.actionsGroup}>
                                        <h3 className={styles.actionsGroupTitle}><FaClipboardList /> Administrativo</h3>
                                        <button onClick={handleOpenNotasModal} className={styles.customButton}><FaStickyNote /> Notas</button>
                                        <button className={styles.customButton} onClick={handleOpenArquivosPopup}>
                                            <FaFolderOpen /> Arquivos
                                        </button>
                                        <button onClick={() => setIsReportModalOpen(true)} className={styles.customButton}><FaFilePdf /> Relatório do Imóvel</button>
                                        <button className={`${styles.customButton} ${styles.editBtn}`} onClick={handleOpenEditModal}><FaEdit /> Editar Imóvel</button>
                                    </div>
                                </div>
                            </div>

                            <ArquivosPopup
                                isOpen={isArquivosPopupOpen}
                                onClose={handleCloseArquivosPopup}
                                imovelId={id}
                            />
                            
                            {/* ===================================================================== */}
                            {/* ===== A LINHA ABAIXO É A ÚNICA ALTERAÇÃO NESTE ARQUIVO ===== */}
                            {/* ===================================================================== */}
                            <InventoryModal isOpen={isInventoryModalOpen} onClose={handleCloseInventoryModal} imovel={imovel} />

                            <EditImovelModal isOpen={isEditModalOpen} onClose={handleCloseEditModal} imovel={imovel} onSave={handleSaveImovel} />
                            <RegisterDespesaPopup isOpen={isDespesaPopupOpen} onClose={handleCloseDespesaPopup} imovelId={id} />
                            <ExpenseTablePopup isOpen={isViewExpensePopupOpen} imovelId={id} onClose={handleCloseViewExpensePopup} />
                            <DesbasteTablePopup isOpen={isDesbasteTableOpen} imovelId={id} onClose={handleCloseDesbasteTable} />
                            <RegisterDesramaPopup isOpen={isDesramaPopupOpen} onClose={() => setIsDesramaPopupOpen(false)} imovelId={id} onUpdateNeeded={fetchImovelDetails} />
                            <DesramaTablePopup isOpen={isDesramaTableOpen} imovelId={id} onClose={handleDesramaTableClose} />
                            <RegisterDesbastePopup isOpen={isDesbastePopupOpen} onClose={handleCloseDesbastePopup} imovelId={id} onUpdateNeeded={fetchImovelDetails} />
                            <NotasModal isOpen={isNotasModalOpen} onClose={handleCloseNotasModal} imovelId={id} />

                            {isReportModalOpen && (
                                <div className={styles.customModal}>
                                    <div className={styles.modalContent}>
                                        <h2 className={styles.modalTitle}>Selecione os Campos para o Relatório</h2>
                                        <div className={styles.customFormGroup}>
                                            <button className={styles.btnSelectAll} onClick={handleSelectAll}>Selecionar/Desselecionar Todos</button>
                                            {Object.keys(imovel)
                                                .filter(key => key !== "id" && key !== "descricao" && formatValue(imovel[key], key) !== null)
                                                .map((key) => {
                                                    const label = fieldLabels[key] || key.replace(/_/g, " ").toUpperCase();
                                                    return (
                                                        <div key={key} className={styles.customCheckbox}>
                                                            <input type="checkbox" id={key} name={key} checked={selectedFields[key] || false} onChange={handleFieldChange} />
                                                            <label htmlFor={key}>{label}</label>
                                                        </div>
                                                    );
                                                })}
                                        </div>
                                        <div className={styles.modalActions}>
                                            <button className={`${styles.btn} ${styles.btnDanger}`} onClick={() => setIsReportModalOpen(false)}>Cancelar</button>
                                            <button className={`${styles.btn} ${styles.btnSuccess}`} onClick={handleGenerateReport}>Gerar Relatório</button>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </>
                    )}
                </>
            )}
        </div>
    );
};

export default ImovelDetails;